import { useEffect, useState } from 'react';
import { useAuth } from '../auth';
import { useI18n } from '../i18n';
import './RankChangeBanner.css';

const API = import.meta.env.VITE_API_URL || 'http://localhost:8000';
const STORAGE_KEY = 'last_known_rank';

export function RankChangeBanner() {
  const { token, user } = useAuth();
  const { locale } = useI18n();
  const [delta, setDelta] = useState<{ from: number; to: number } | null>(null);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    if (!token || !user?.id) return;
    let aborted = false;
    fetch(`${API}/stats/season/leaderboard?limit=200`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(r => (r.ok ? r.json() : null))
      .then(data => {
        if (aborted || !data?.my_rank) return;
        const newRank: number = data.my_rank;
        const key = `${STORAGE_KEY}_${user.id}`;
        const prev = localStorage.getItem(key);
        if (prev !== null) {
          const prevRank = parseInt(prev, 10);
          if (!isNaN(prevRank) && prevRank !== newRank) {
            setDelta({ from: prevRank, to: newRank });
            setTimeout(() => setHidden(true), 4500);
          }
        }
        localStorage.setItem(key, String(newRank));
      })
      .catch(() => {});
    return () => { aborted = true; };
  }, [token, user?.id]);

  if (!delta || hidden) return null;
  const up = delta.to < delta.from;
  const places = Math.abs(delta.from - delta.to);
  const upTxt = locale === 'en'
    ? `↑ Climbed ${places} place${places > 1 ? 's' : ''}!`
    : `↑ ${places} sıra yükseldin!`;
  const downTxt = locale === 'en'
    ? `↓ Dropped ${places} place${places > 1 ? 's' : ''}`
    : `↓ ${places} sıra düştün`;

  return (
    <div className={`rank-banner ${up ? 'is-up' : 'is-down'}`} onClick={() => setHidden(true)}>
      <span className="rank-banner-icon">{up ? '🚀' : '📉'}</span>
      <span className="rank-banner-text">
        <strong>{up ? upTxt : downTxt}</strong>
        <span className="rank-banner-detail">#{delta.from} → #{delta.to}</span>
      </span>
    </div>
  );
}
